import { Champ } from './champ';
import { Onglet } from './onglet';
import { Section } from './section';

export interface IChampOnglet {
    id?: string;
    champId: string;
    ongletId: string;
    ligne: number;
    colonne?: number;
    readOnly?: boolean;
    secId?: string;
}

export class ChampOnglet implements IChampOnglet {

    id?: string;
    champId: string;
    ongletId: string;
    entiteId: string;
    ligne: number;
    colonne?: number;
    readOnly?: boolean;
    secId?: string;

    champ?: Champ;
    onglet?: Onglet;
    section?: Section;

    constructor(champsOnglet: IChampOnglet) {
        this.id         = champsOnglet.id;
        this.champId    = champsOnglet.champId;
        this.ongletId   = champsOnglet.ongletId;
        this.ligne      = champsOnglet.ligne;
        this.colonne    = champsOnglet.colonne;
        this.readOnly   = champsOnglet.readOnly;
        this.secId      = champsOnglet.secId;
    }

    static fromJson(champsOnglet: any): ChampOnglet {
        return new ChampOnglet({
            id: champsOnglet.cho_id,
            champId: champsOnglet.cho_chp_id,
            ongletId: champsOnglet.cho_ong_id,
            ligne: champsOnglet.cho_ordre,
            colonne: champsOnglet.cho_colonne,
            readOnly: champsOnglet.cho_readonly,
            secId: champsOnglet.cho_sec_id
        });
    }

    toJson() {
        return {
            cho_id: this.id,
            cho_chp: this.champ.toJson(),
            cho_ong: this.onglet.toJson(),
            cho_ordre: this.ligne,
            cho_colonne: this.colonne,
            cho_readonly: this.readOnly,
            cho_sec_id: this.secId,
        };
    }

}



